import { createWebsiteChannel } from './channel.js';
export const createHost = function (config) {
    const clientSdk = (typeof $wixContext !== 'undefined' ? $wixContext.clientSdk : undefined) ??
        config?.clientSdk ??
        (typeof window !== 'undefined' ? window?.clientSdk : undefined);
    const { applicationId } = config || {};
    if (!applicationId) {
        throw new Error('"createHost" was called without a required field "applicationId"');
    }
    return {
        // environment: {},
        channel: createWebsiteChannel({ clientSdk, applicationId }),
        close: () => { },
    };
};
//# sourceMappingURL=hostPlatform.js.map